<template>
  <v-list-item v-if="isMenu" :href="sessionHistoryUrl" target="_blank">
    <v-list-item-action>
      <v-icon>fa-history</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>Historial de sesiones</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
  <div v-else class="text-right fh-content">
    <a class="fh-link" :href="sessionHistoryUrl" target="_blank">
      Acceso anterior: {{ fechaHoraAccesoAnterior | fhDynamicVerboseDateTimeUtc }}
    </a>
  </div>
</template>

<script>
import SessionService from '@/services/SessionService'
import {SESSION_HISTORY_URL} from '@/config'

export default {
  name: 'FhAccesoAnterior',
  props: {
    isMenu: Boolean,
  },
  computed: {
    fechaHoraAccesoAnterior() {
      return SessionService.getFechaHoraAccesoAnterior()
    },
    sessionHistoryUrl() {
      return SESSION_HISTORY_URL
    },
  },
}
</script>

<style scoped>
.fh-content {
  font-size: 14px;
  margin-right: 16px;
  margin-top: 8px;
}

.fh-link {
  color: #333;
  text-decoration: none;
}
</style>
